import styled, { css } from 'styled-components';

export const GameUIMenuImgWrapper = styled.div<{
  $useShadow?: boolean;
  $shadowColor?: string;
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s;
  flex-direction: column;
  
  img {
    width: 100%;
    object-fit: contain;
    ${({ $useShadow, $shadowColor }) =>
    $useShadow
      ? css`filter: drop-shadow(0 2px 8px ${$shadowColor || 'rgba(0,0,0,0.35)'});`
      : css``}
  }
  
  .menu-title {
    font-size: 10px;
    color: var(--menuTextColor);
    text-align: center;
    line-height: 1.2;
    font-family: var(--menuFontFamily);
    /* 📍 텍스트 오버플로우 처리 */
    word-break: break-word;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
  }
    &:hover {
      cursor: var(--hoverCursorURL), pointer;
      transform: translateY(-1px);
    }
`;

export const GameUIMenuItem = styled.div`
  /* 공통 스타일 */
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s;
  border-radius: var(--cardBorderRadius);
  background-color: var(--menuBackgroundColor);
  color: var(--menuTextColor);
  border: 1px solid var(--lineColor);
  
  /* 📍 max-width 대응: 컨테이너 크기에 맞게 조정 */
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  padding: 8px 12px;
    font-family: var(--menuFontFamily);
    font-size: 14px;
    width: 100%;
    height: 100%;
    min-height: 40px; /* 최소 높이 보장 */
    
    /* 📍 텍스트 오버플로우 처리 */
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    
    /* 📍 작은 컨테이너에서 폰트 크기 자동 조정 */
    @media (max-width: 120px) {
      font-size: 12px;
      padding: 6px 8px;
    }
  /* 호버 효과 */
  &:hover {
    cursor: var(--hoverCursorURL), pointer;
    background: rgba(var(--primaryColorRGB), 0.1);
    transform: translateY(-1px);
    
  }
`;
